import styled, { css } from 'styled-components';
import { FlexibleDiv } from '../../../../../styled/common';

export const ValidationWrapper = styled(FlexibleDiv)`
  flex-direction: row-reverse;
`;

export const blockContentStyles = css`
  gap: 0;

  @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    gap: 0;
  }
`;

export const TextAreaWrapper = styled.div`
  min-height: 240px;
  max-height: 300px;

  @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    min-height: 210px;
  }

  > div {
    border-radius: 14px;
    border: 1px solid ${({ theme }) => theme.colors.border.secondary};
    background-color: ${({ theme }) => theme.colors.background.tertiary};
    padding: 15px;
    max-height: inherit;
    min-height: inherit;

    > textarea {
      background-color: ${({ theme }) => theme.colors.background.tertiary};
      height: 100%;
      max-height: inherit;
      min-height: inherit;
      padding: 0;

      &::placeholder {
        color: ${({ theme }) => theme.colors.text.secondary};
        font-size: 15px;
      }
    }
  }
`;
